import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliImballoModalEditComponent.vue?vue&type=template&id=c258b568"
import script from "./ConfigurazioniMagazzinoArticoliImballoModalEditComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliImballoModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports